import { apiStudent } from '@/lib/api-manager'

export async function generateAndReturnEquivalencesByRequest(
  requestId?: string
) {
  return (
    await apiStudent.post(`v1/requests/request/${requestId}/equivalences`)
  ).data.data
}
